export default __webpack_public_path__ + "static/media/colorpop.cc6adcd1.gif";